function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createElement as _createElement } from "react";
import React, { Fragment, useMemo } from "react";
import ChevronDownIcon from "../../Icon/ChevronDown";
import Button from "../../Button/Button";
import Menu from "../../Menu/Menu";
import { buildTestIdProp } from "@cvent/nucleus-test-automation";
import { generateMenuData } from "../utils/helpers";
export default function DefaultActions(param) {
    var actions = param.actions, isRtl = param.isRtl, testID = param.testID, moreActionsText = param.moreActionsText;
    var ref = useMemo(function() {
        return generateMenuData(actions, false);
    }, [
        actions
    ]), menuOptions = ref.menuOptions, menuSelectFunction = ref.menuSelectFunction;
    return _jsx(Fragment, {
        children: actions.length <= 2 ? _jsx(Fragment, {
            children: actions.map(function(element, i) {
                var appearance = element.appearance, value = element.value, disabled = element.disabled, onClick = element.onClick;
                return _createElement(Button, _objectSpread({}, buildTestIdProp([
                    testID,
                    value
                ]), {
                    key: value,
                    appearance: i === 0 ? appearance !== null && appearance !== void 0 ? appearance : 'filled' : appearance !== null && appearance !== void 0 ? appearance : 'lined',
                    text: value,
                    disabled: disabled,
                    onClick: onClick,
                    isRtl: isRtl
                }));
            })
        }) : _jsx(Fragment, {
            children: actions.length > 0 && _jsxs(Fragment, {
                children: [
                    _jsx(Menu, {
                        testID: testID,
                        options: menuOptions,
                        onSelect: function(selection) {
                            return menuSelectFunction(selection);
                        },
                        trigger: function(handlePress) {
                            return _jsx(Button, _objectSpread({}, buildTestIdProp([
                                testID,
                                'lined-button'
                            ]), {
                                appearance: "lined",
                                text: moreActionsText,
                                onClick: handlePress,
                                icon: ChevronDownIcon,
                                iconAlign: "end",
                                isRtl: isRtl
                            }));
                        },
                        placement: "bottom-start"
                    }),
                    _jsx("div", {
                        css: {
                            flexShrink: 0
                        },
                        children: _jsx(Button, _objectSpread({}, buildTestIdProp([
                            testID,
                            'filled-button'
                        ]), {
                            appearance: !actions[0].appearance ? 'filled' : actions[0].appearance,
                            text: actions[0].value,
                            disabled: actions[0].disabled,
                            onClick: actions[0].onClick,
                            isRtl: isRtl
                        }))
                    })
                ]
            })
        })
    });
};
